import { render, staticRenderFns } from "./StallionStockDistant.vue?vue&type=template&id=f2623a7c&"
import script from "./StallionStockDistant.vue?vue&type=script&lang=js&"
export * from "./StallionStockDistant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports